<tran-application-detail-dashboard-box [heading]="heading()">
    @if (isLoading()) {
        <div class="py-4 flex flex-col gap-4" aria-hidden="true">
            <span class="si-skeleton placeholder-lg w-[50%]"></span>
            <span class="si-skeleton placeholder-lg w-full"></span>
            <span class="si-skeleton placeholder-lg w-[80%]"></span>
        </div>
    } @else {
        <form [formGroup]="activeForm()">
            <si-form-item
                [required]="isSubjectAreaRequired()"
                [label]="
                    'components.application-detail-dashboard.application-additional-subject-areas.topics' | translate
                "
            >
                @if (!readonly()) {
                    <tran-subject-area-selector
                        [predefinedControl]="activeForm().controls.subjectAreas"
                        [customControl]="activeForm().controls.additionalSubjectAreas"
                        [subjectAreas]="allPredefinedSubjectAreas()"
                        [showRequiredMarker]="false"
                    />
                } @else {
                    <si-pills-input
                        [placeholder]="
                            'components.application-detail-dashboard.application-additional-subject-areas.topics'
                                | translate
                        "
                        [formControl]="subjectAreasDisplayControl"
                        [readonly]="readonly()"
                    />
                }
            </si-form-item>
        </form>
    }
</tran-application-detail-dashboard-box>
